import React from 'react';
import Icon from '../../../components/AppIcon';

const PromptTipsSidebar = () => {
  const tips = [
    {
      icon: 'Lightbulb',
      title: 'Be Specific',
      description: 'Include details about features, user roles, and core functionality you need.'
    },
    {
      icon: 'Target',
      title: 'Define Purpose',
      description: 'Clearly state what problem your application solves and who will use it.'
    },
    {
      icon: 'Users',
      title: 'Mention User Types',
      description: 'Specify different user roles like admin, customer, vendor, etc.'
    },
    {
      icon: 'Database',
      title: 'Data Requirements',
      description: 'Describe what data needs to be stored and how it relates to each other.'
    },
    {
      icon: 'Zap',
      title: 'Key Features',
      description: 'List the most important features your application must have.'
    }
  ];

  const supportedTypes = [
    { icon: 'ShoppingCart', label: 'E-commerce' },
    { icon: 'Users', label: 'Social Media' },
    { icon: 'Briefcase', label: 'Business Tools' },
    { icon: 'GraduationCap', label: 'Education' },
    { icon: 'Heart', label: 'Healthcare' },
    { icon: 'Home', label: 'Real Estate' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="BookOpen" size={20} className="text-primary" />
          <h3 className="text-base md:text-lg font-semibold">Writing Tips</h3>
        </div>
        <div className="space-y-3 md:space-y-4">
          {tips?.map((tip, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={tip?.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold mb-1">{tip?.title}</h4>
                <p className="text-xs md:text-sm text-muted-foreground">{tip?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Sparkles" size={20} className="text-primary" />
          <h3 className="text-base md:text-lg font-semibold">Supported Types</h3>
        </div>
        <div className="grid grid-cols-2 gap-2 md:gap-3">
          {supportedTypes?.map((type, index) => (
            <div
              key={index}
              className="flex items-center gap-2 p-2 md:p-3 bg-muted rounded-lg"
            >
              <Icon name={type?.icon} size={16} className="text-primary flex-shrink-0" />
              <span className="text-xs md:text-sm font-medium truncate">{type?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromptTipsSidebar;